<template>
  <div
    class="
      absolute
      top-0
      left-0
      w-full
      h-full
      bg-black
      flex flex-col
      items-center
      rounded-xl
      justify-center
      gap-2
      pb-4
      border border-grey
    "
  >
    <ViceAvatar :name="name" :image="profile_photo_url" class="w-20 h-20 text-2xl min-h-20" />
    <div class="flex items-center text-white text-center font-bold">
      <ShieldExclamationIcon class="mr-2 w-6 h-5" />
      Stream turned off
    </div>
  </div>
</template>

<script>
import { ShieldExclamationIcon } from '@heroicons/vue/solid';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';

export default {
  name: 'UserTurnedStreamOffTile',
  props: {
    profile_photo_url: {
      type: String,
    },
    name: {
      type: String,
    },
  },

  components: {
    ShieldExclamationIcon,
    ViceAvatar,
  },
};
</script>
